import { getSelfEnteredInformation } from './sei-api';

export const getAllSelfEnteredData = () => {
  return getSelfEnteredInformation();
};
